
import { computed, defineComponent, PropType, onMounted, ref } from "vue";

import { Tags } from "@/interfaces/work";
import animateCursor from "@/components/Shared/Cursor/animate";
import { animateWorkItem } from "@/components/SelectedWork/WorkItem/animate";

export default defineComponent({
  name: "WorkItem",
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    banner: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    tags: {
      type: Array as PropType<Tags>,
      required: true,
    },
    info: {
      type: String,
      required: true,
    },
    openModal: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },
  setup(props) {
    const figureRef = ref(null);
    const personalProjectTag = "Personal Project";
    const corporateWorkTag = "Corporate Work";

    const projectType = computed(() =>
      props.tags.includes(personalProjectTag)
        ? personalProjectTag
        : corporateWorkTag
    );

    const technologyTags = computed(() =>
      props.tags.filter(
        (tag) => tag !== personalProjectTag && tag !== corporateWorkTag
      )
    );

    const projectTypeClass = computed(() => ({
      "work__project_type--personal": projectType.value === personalProjectTag,
      "work__project_type--corporate": projectType.value === corporateWorkTag,
    }));

    onMounted(() => {
      animateCursor();
      if (figureRef.value) {
        animateWorkItem(figureRef.value);
      }
    });

    return {
      figureRef,
      projectType,
      technologyTags,
      projectTypeClass,
    };
  },
});
